var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M32.09 23.613C35.286 21.851 42 17.496 42 12c0-2.757-2.243-5-5-5-.353 0-.701.05-1.044.126C35.983 6.425 36 5.718 36 5a1 1 0 0 0-1-1H13a1 1 0 0 0-1 1c0 .718.017 1.425.044 2.126A4.823 4.823 0 0 0 11 7c-2.757 0-5 2.243-5 5 0 5.495 6.715 9.851 9.91 11.614 1.418 2.669 3.154 4.626 5.09 5.628V32h-7a1 1 0 0 0-1 1v5h-1a1 1 0 0 0-1 1v4a1 1 0 0 0 1 1h24a1 1 0 0 0 1-1v-4a1 1 0 0 0-1-1h-1v-5a1 1 0 0 0-1-1h-7v-2.759c1.936-1.002 3.672-2.959 5.09-5.628zM37 9c1.654 0 3 1.346 3 3 0 3.404-3.65 6.504-6.487 8.403 1.176-3.173 1.988-6.972 2.319-11.155A2.94 2.94 0 0 1 37 9zM8 12c0-1.654 1.346-3 3-3 .4 0 .796.087 1.169.248.331 4.183 1.142 7.982 2.318 11.154C11.65 18.503 8 15.403 8 12zm6.01-6h19.98c-.237 12.025-4.715 22-9.99 22s-9.753-9.975-9.99-22zM35 42H13v-2h22zm-2-4H15v-4h18zm-8-6h-2v-2.089c.33.054.663.089 1 .089s.67-.035 1-.089z",
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRace);
export default __webpack_public_path__ + "static/media/race.68e51e7dfeb35c6b044128002786f961.svg";
export { ForwardRef as ReactComponent };